module.exports = __webpack_public_path__ + "media/iconic/map-marker-2beb767d.svg";